import React from 'react';
import css from '../../../../styles/modules/PaymentSummary/financials.module.css';
import { NumericFormat } from 'react-number-format';

export default function Financials({
  purpose,
  creditTraceID,
  referenceID,
  tenantName,
  logoURL,
  srcBank,
  fee,
  amount,
  debitMethod,
}) {
  const total = (Number(fee) + Number(amount)).toFixed(2);

  return (
    <div className={css.wrapper}>
      <div className={css.topContainer}>
        <div className={css.topLeft}>
          <p className={css.subHeadlines}>From</p>
          <p className={css.textRegular}>
            {`${srcBank?.bankName || ''}${
              srcBank?.accountLastFourDigits
                ? ` x${srcBank?.accountLastFourDigits}`
                : ''
            }`}
          </p>
        </div>
        <div className={css.topRight}>
          <img className={css.institutionLogo} src={logoURL} />
        </div>
      </div>
      <div className={css.middleContainer}>
        <p className={css.subHeadlines}>Method</p>
        <p className={css.textRegular}>{debitMethod ? debitMethod : ' '}</p>
      </div>
      <div className={css.middleContainer}>
        <p className={css.subHeadlines}>Statenent Description</p>
        <p className={css.textRegular}>
          {creditTraceID || referenceID || tenantName
            ? `paymints.io ${creditTraceID || ''} ${referenceID || ''} ${
                tenantName || ''
              }`
            : ''}
        </p>
      </div>

      <div className={css.bottomContainer}>
        <p className={css.subHeadlines}>Amount</p>
        <div className={css.calcAmount}>
          <p style={{ marginTop: '10px' }} className={css.calculationItems}>
            {purpose}
          </p>
          <NumericFormat
            displayType="text"
            fixedDecimalScale={true}
            prefix="$"
            value={Number(amount).toFixed(2)}
            decimalScale={2}
            thousandsGroupStyle="thousand"
            thousandSeparator=","
          />
        </div>
        <div style={{ marginTop: '10px' }} className={css.calcAmount}>
          <p style={{ marginTop: '0px' }} className={css.calculationItems}>
            Fee
          </p>
          <NumericFormat
            displayType="text"
            fixedDecimalScale={true}
            prefix="$"
            value={Number(fee).toFixed(2)}
            decimalScale={2}
            thousandsGroupStyle="thousand"
            thousandSeparator=","
          />
        </div>
        <hr className={css.line} />
        <div style={{ marginTop: '10px' }} className={css.calcAmount}>
          <p style={{ marginTop: '0px' }} className={css.calculationItemsTotal}>
            Total
          </p>
          <NumericFormat
            className={css.dollarAmount}
            fixedDecimalScale={true}
            displayType="text"
            prefix="$"
            value={total}
            decimalScale={2}
            thousandsGroupStyle="thousand"
            thousandSeparator=","
          />
        </div>
      </div>
    </div>
  );
}
